// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "04ddf3ff5ac4c75fe9a8" + "-chunk.js";
};